import { DbCommon } from "../constants/dbCommon";

export class MemberSearchPayload {
    emailQ: string;
    employeeIDQ: string;
    firstNameQ: string;
    isPrimaryQ: boolean;
    isTestQ: boolean;
    last4SSNQ: string;
    lastNameQ: string;
    payrollNumberQ: string;
    phoneQ: string;
    ssnQ: string;
    systemNumberQ: number;
    agentID: number;
    companyID: number;

    constructor() {
        this.emailQ = '';
        this.employeeIDQ = '';
        this.firstNameQ = '';
        this.isPrimaryQ = false;
        this.isTestQ = false;
        this.last4SSNQ = '';
        this.lastNameQ = '';
        this.payrollNumberQ = '';
        this.phoneQ = '';
        this.ssnQ = '';
        this.systemNumberQ = DbCommon.emptyInt;
        this.agentID = null;
        this.companyID = 0;
    }

    isCompanyOnly(): boolean {
        return !this.emailQ &&
            !this.employeeIDQ &&
            !this.firstNameQ &&
            !this.last4SSNQ &&
            !this.lastNameQ &&
            !this.payrollNumberQ &&
            !this.ssnQ &&
            (!this.systemNumberQ || this.systemNumberQ == DbCommon.emptyInt) &&
            this.companyID > 0;
    }
}


export class MemberSearchResultResponse {
    matchingMembers: MemberSearchResult[];

    constructor() {
        this.matchingMembers = new Array<MemberSearchResult>();
    }
}

export class MemberSearchResult {
    systemNumber: number;
    firstName: string;
    lastName: string;
    status: string;
    ssn: string;
    companyName: string;
    employeeID: string;
    payrollNumber: string;
    homeEmail: string;
    homePhone: string;
    birthDate: string;
    memberName: string;
    isVerified: boolean;

    constructor() {
        this.systemNumber = null;
        this.firstName = null;
        this.lastName = null;
        this.status = null;
        this.ssn = null;
        this.companyName = null;
        this.employeeID = null;
        this.payrollNumber = null;
        this.homeEmail = null;
        this.homePhone = null;
        this.birthDate = null;
        this.memberName = null;
        this.isVerified = false;
    }
}

export class ConfirmMember {
    homeEmail: string;
    cannotContinueMessage: string;
    showCallerID: boolean;
    division: string;
    eeClass1: string;
    eeClass2: string;
    eeClass3: string;
    eeClass4: string;
    eeClass5: string;
    location: string;
    department: string;
    position: string;
    divisionCaption: string;
    eeClass1Caption: string;
    eeClass2Caption: string;
    eeClass3Caption: string;
    eeClass4Caption: string;
    eeClass5Caption: string;
    locationCaption: string;
    departmentCaption: string;
    positionCaption: string;
    employmentStatus: string;
    version: string;

    constructor() {
        this.homeEmail = null;
        this.cannotContinueMessage = null;
        this.showCallerID = false;
        this.division = null;
        this.eeClass1 = null;
        this.eeClass2 = null;
        this.eeClass3 = null;
        this.eeClass4 = null;
        this.eeClass5 = null;
        this.location = null;
        this.department = null;
        this.position = null;
        this.divisionCaption = null;
        this.eeClass1Caption = null;
        this.eeClass2Caption = null;
        this.eeClass3Caption = null;
        this.eeClass4Caption = null;
        this.eeClass5Caption = null;
        this.locationCaption = null;
        this.departmentCaption = null;
        this.positionCaption = null;
        this.employmentStatus = null;
        this.version = null;
    }
}